import { LoginConfig } from "@layout/login";
import { createLogger, Logger, LoggerConfig, LogLevel } from "@core/logger";
import { TokenReceiverConfig } from "@layout/tokenreceiver";
import { LogoutConfig } from "@layout/logout";
import { NotFoundConfig } from "@layout/notfound";
import { HeaderConfig } from "@layout/header";
import { FooterConfig } from "@layout/footer";
// import { pubSubInstance } from "@core/pubsub";
import { ChatConfig } from "@widget/chat";

const CommonLoggerConfig: LoggerConfig = {
  logLevel: LogLevel.DEBUG,
  serverLogLevel: LogLevel.OFF,
  apiEndpoint: '',
  authToken: ''
}

/**
 * Login Config
 */
export const loginConfig: LoginConfig = {
  logConfig: CommonLoggerConfig,
  styleConfig: {
    styleName: 'STYLE_1',
    themeType: 'LIGHT'
  },
  instanceConfig: {
    eventId: 'LOGIN_EVENT',
    instanceId: 'LOGIN_INSTANCE'
  },
  apiConfig: {
    loginUrl: import.meta.env.VITE_API_HOST + import.meta.env.VITE_LOGIN_URL,
    ssoUrl: import.meta.env.VITE_API_HOST + import.meta.env.VITE_LOGIN_SSO
  },
  appConfig: { storage: "LOCAL_STORAGE", tokenReceiverUrl: '/token-receiver', validLoginRedirectUrl: '/home', logoPath: '/infosphere-logo.png' },
  formConfig: [
    {
      id: 'field1',
      name: 'email',
      type: "email",
      defaultValue: '',
      isHidden: false,
      isrequired: true,
      placeholder: 'email@infoorigin.com'
    },
    {
      id: 'field2',
      name: 'password',
      type: "password",
      defaultValue: '',
      isHidden: false,
      isrequired: true,
      placeholder: 'Your secure password'
    }
  ]

}

/**
 * Common pubsub instance
 */
// export const pubSub = pubSubInstance({
//   logLevel: LogLevel.DEBUG,
//   serverLogLevel: LogLevel.OFF,
//   apiEndpoint: '',
//   authToken: ''
// })

/**
 * Token receiver config
 */
export const tokenReceiverConfig: TokenReceiverConfig = {
  logConfig: CommonLoggerConfig,
  styleConfig: {
    styleName: 'STYLE_1',
    themeType: 'LIGHT'
  },
  instanceConfig: {
    eventId: 'TOKEN_RECEIVER_EVENT',
    instanceId: 'TOKEN_RECEIVER_INSTANCE'
  },
  appConfig: { storage: "LOCAL_STORAGE", validLoginRedirectUrl: '/home' }
}

/**
 * Logout config
 */
export const logoutConfig: LogoutConfig = {
  logConfig: CommonLoggerConfig,
  styleConfig: {
    styleName: 'STYLE_1',
    themeType: 'LIGHT'
  },
  instanceConfig: {
    eventId: 'LOGOUT_EVENT',
    instanceId: 'LOGOUT_INSTANCE'
  },
  appConfig: {
    storage: "LOCAL_STORAGE",
    redirectUrl: '/login',
    logoPath: '/infosphere-logo.png'
  }
}

export const notfoundConfig: NotFoundConfig = {
  logConfig: CommonLoggerConfig,
  styleConfig: {
    styleName: 'STYLE_1',
    themeType: 'LIGHT'
  },
  instanceConfig: {
    eventId: 'NOTFOUND_EVENT',
    instanceId: 'NOTFOUND_INSTANCE'
  },
  appConfig: {
    redirectUrl: '/home'
  }

}

export const headerConfig: HeaderConfig = {
  logConfig: CommonLoggerConfig,
  styleConfig: {
    styleName: 'STYLE_2',
    themeType: 'LIGHT'
  },
  instanceConfig: {
    eventId: 'HEADER_EVENT',
    instanceId: 'HEADER_INSTANCE'
  },
  appConfig: { companyLogo: '/logo-dark.png', appLogo: '/infosphere-logo.png', storage: "LOCAL_STORAGE", userProfileKey: 'userDetail' },
  headerContent: {
    menuOptions: [{
      id: 1,
      type: "link",
      title: "Home",
      targetUrl: '/home'
    }],
    searchBlock: {
      isSearchEnabled: true,
      searchPlaceholder: "Search your bulletin",
      content: []
    }
  }
}

export const footerConfig: FooterConfig = {
  logConfig: CommonLoggerConfig,
  styleConfig: {
    styleName: 'STYLE_2',
    themeType: 'LIGHT'
  },
  instanceConfig: {
    eventId: 'FOOTER_EVENT',
    instanceId: 'FOOTER_INSTANCE'
  },
  appConfig: {
    copyrightOwner: "Info Origin Pvt. Ltd."
  }
}

export const chatConfig: ChatConfig = {
  logConfig: {
    logLevel: LogLevel.OFF,
    serverLogLevel: LogLevel.OFF,
    apiEndpoint: '',
    authToken: ''
  },
  styleConfig: { styleName: 'STYLE_1', themeType: 'LIGHT' },
  instanceConfig: { eventId: 'DEFAULT_EVENT_CHAT_WIDGET', instanceId: 'DEFAULT_INSTANCE_CHAT_WIDGET' },
  apiConfig: {
    chatUrl: import.meta.env.VITE_API_HOST,
    sseUrl: import.meta.env.VITE_API_HOST,
    conversationUrl: import.meta.env.VITE_API_HOST,
    convoBiUrl: import.meta.env.VITE_API_HOST
  },
  appConfig: {
    storage: "LOCAL_STORAGE",
    userDetailKey: 'userDetail'
  }
}

export function initializeLogger(): Logger {
  return createLogger(CommonLoggerConfig);
}